import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { ActiveDataResult } from '@typesApp/ClaimRecord'
import { useSessionInfo } from '@hooks/useSessionInfo'
import { useLazyGetActiveClaimRecordQuery } from '@redux/queries/claimRecords'
import { setActiveClaimRecord } from '@redux/slices/claimStatusSlice'

type UseActiveDataReturn = {
  fetchActiveData: (id?: string) => Promise<ActiveDataResult>
}

export const useActiveData = (): UseActiveDataReturn => {
  const dispatch = useDispatch()
  const { customer: sessionCustomer } = useSessionInfo()
  const [fetchActive] = useLazyGetActiveClaimRecordQuery()

  const fetchActiveData = useCallback(
    async (id?: string): Promise<ActiveDataResult> => {
      const customerNumber = id ?? sessionCustomer?.id
      if (!customerNumber) throw new Error('Customer number required to fetch active data!')

      const result = await fetchActive({ customerNumber }).unwrap()
      dispatch(setActiveClaimRecord(result?.id))

      return result
    },
    [dispatch, fetchActive, sessionCustomer?.id]
  )

  return {
    fetchActiveData,
  }
}
